import { render, staticRenderFns } from "./notifier-settings.vue?vue&type=template&id=1bcaf27d&scoped=true"
import script from "./notifier-settings.vue?vue&type=script&lang=js"
export * from "./notifier-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcaf27d",
  null
  
)

export default component.exports